import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "onClick"]

import { useCheckout } from '@/b2b/checkout/useCheckout';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentFinalizeHasSufficientPayments',
  setup(__props) {

const labels = useBlockLabels();
const { submitOrderWithSufficientPaymentsInBasket, initializePayment, setItemIdsOutOfStock, setEarliestDeliveryDateChanged } = useCheckout();
const pending = ref<boolean>(false);

const startPayment = async() => {
    const result = await initializePayment();
    if (result.itemsOutOfStock?.length) {
        setItemIdsOutOfStock(result.itemsOutOfStock);
    } else if (result.requiredEarliestDeliveryDate) {
        setEarliestDeliveryDateChanged(true);
    } else {
        pending.value = true;
        await submitOrderWithSufficientPaymentsInBasket();
        pending.value = false;
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "c-button c-button--primary",
    disabled: _ctx.disabled || pending.value,
    onClick: _withModifiers(startPayment, ["prevent"])
  }, _toDisplayString(_unref(labels).paymentStepButtonPlaceOrder), 9, _hoisted_1))
}
}

})